<template>
  <div id="setting-event" class="col-12" @mouseleave="updateEvents">
    <div class="form">
      <dl class="row">
        <dt class="col-md-3">เงื่อนไขการรับสิทธิ์</dt>
        <dd class="col-md-9">
          <label :class="isDisabledClass" class="select-input">
            <span>รับสิทธิ์ทันที</span>
            <input
              v-model="events.type"
              :disabled="!canUpdateContent"
              type="radio"
              value="IMMEDIATE"
              name="type"
            />
            <span class="checkmark radio"></span>
          </label>
          <label :class="isDisabledClass" class="select-input">
            <span>ลงทะเบียน</span>
            <input
              v-model="events.type"
              :disabled="!canUpdateContent"
              type="radio"
              value="REGISTER"
              name="type"
            />
            <span class="checkmark radio"></span>
          </label>
          <dl v-if="showTypeOptions" class="form-options">
            <dt></dt>
            <dd>
              <label :class="isDisabledClass" class="select-input">
                <span>ให้มีคำถามในหน้าแบบฟอร์มลงทะเบียน</span>
                <input
                  v-model="conditions.question"
                  :disabled="!canUpdateContent"
                  type="checkbox"
                />
                <span class="checkmark checkbox"></span>
              </label>
              <div v-if="showTypeQuestionOptions" class="sub-input w-100">
                <small>พิมพ์คำถามที่คุณต้องการ</small>
                <input
                  v-model="events.question"
                  :disabled="!canUpdateContent"
                  type="text"
                  name="question"
                  class="form-control"
                />
              </div>
            </dd>
          </dl>
        </dd>
        <dt class="col-md-3">รูปแบบ Ticket</dt>
        <dd :class="isDisabledClass" class="col-md-9">
          <label class="select-input">
            <span>Activity Ticket</span>
            <input
              v-model="events.usageType"
              :disabled="!canUpdateContent"
              type="radio"
              value="ACTIVITY"
              name="usageType"
            />
            <span class="checkmark radio"></span>
          </label>
          <label class="select-input">
            <span>Redeem Ticket</span>
            <input
              v-model="events.usageType"
              :disabled="!canUpdateContent"
              type="radio"
              value="REDEEM"
              name="usageType"
            />
            <span class="checkmark radio"></span>
          </label>
        </dd>

        <dt class="col-md-3">ระยะเวลารับสิทธิ์ / ลงทะเบียน</dt>
        <dd :class="isDisabledClass" class="col-md-9">
          <label class="form-group">
            <input
              v-validate="'required'"
              :value="activateDate[0]"
              :disabled="!canUpdateContent"
              type="hidden"
              name="activateDate"
            />
            <small>วันที่ / เวลา</small>
            <div class="clearfix">
              <el-date-picker
                v-model="activateDate"
                :class="{ error: errors.has('activateDate') }"
                :editable="false"
                :picker-options="datePickerOptions.notBeforeToday"
                :default-time="['00:00:00', '23:59:59']"
                :disabled="!canUpdateContent"
                format="dd-MM-yyyy HH:mm"
                start-placeholder="เริ่มการลงทะเบียน"
                end-placeholder="สิ้นสุดการลงทะเบียน"
                range-separator="ถึง"
                type="datetimerange"
                @blur="validate"
              >
              </el-date-picker>
            </div>
          </label>
        </dd>

        <dt class="col-md-3">รูปแบบรหัส</dt>
        <dd :class="isDisabledClass" class="col-md-9">
          <label class="select-input">
            <span>กำหนดเอง</span>
            <input
              v-model="conditions.codeType"
              :disabled="!canUpdateContent"
              type="radio"
              value="PREFIXED"
            />
            <span class="checkmark radio"></span>
          </label>
          <label class="select-input">
            <span>อัพโหลดไฟล์รหัส</span>
            <input
              v-model="conditions.codeType"
              :disabled="!canUpdateContent"
              type="radio"
              value="PREDEFINED"
            />
            <span class="checkmark radio"></span>
          </label>

          <dl class="form-options">
            <div v-if="showRandomCodeOptions">
              <dt>กำหนดรูปแบบรหัส</dt>
              <dd>
                <label class="form-group">
                  <small>ระบุภาษาอังกฤษขึ้นต้น 2 ตัว</small>
                  <input
                    v-model="events.prefixCode"
                    :disabled="!canUpdateContent"
                    type="text"
                    value="SC"
                    name="prefixCode"
                    class="form-control"
                    maxlength="2"
                    placeholder="SC"
                  />
                </label>
                <label class="form-group">
                  <small>ตัวอย่างรหัส</small>
                  <div class="code-preview">
                    <em>{{ events.prefixCode }}</em>
                    <span>XXXXXX</span>
                  </div>
                </label>
              </dd>
            </div>
            <div v-if="showUploadCodeOptions">
              <dt>
                อัพโหลดไฟล์ CSV
                <img
                  class="pointer align-top ms-2"
                  src="/static/icons/information-circle.svg"
                  alt="info icon"
                  width="22"
                  height="22"
                  @click="showDialog = true"
                />
              </dt>
              <dd>
                <label class="form-group">
                  <input
                    :disabled="!canUpdateContent"
                    type="file"
                    class="form-control"
                    accept=".csv"
                    @change="readCodesFromCSV($event.target.files[0])"
                  />
                </label>
                <label class="form-group">
                  <small>จำนวนสิทธิ์</small>
                  <input
                    v-model="file.codes.length"
                    type="text"
                    class="form-control"
                    readonly
                  />
                </label>
                <div class="code-results">
                  <ul v-if="file.codes.length > 0" class="">
                    <li>ตัวอย่างรหัสจากไฟล์</li>
                    <li v-for="(code, i) in file.codes" :key="i">{{ code }}</li>
                  </ul>
                  <ul v-if="file.errors.length > 0" class="error">
                    <li>พบข้อผิดพลาดกับโค้ดต่อไปนี้</li>
                    <li v-for="(code, i) in file.errors" :key="i">
                      {{ code }}
                    </li>
                  </ul>
                </div>
              </dd>
            </div>
            <dt>วันจัดกิจกรรม / ระยะเวลาใช้สิทธิ์</dt>
            <dd>
              <label class="form-group">
                <input
                  v-validate="'required'"
                  :value="useDate[0]"
                  type="hidden"
                  name="useDate"
                />
                <small>วันที่ / เวลา</small>
                <div class="clearfix">
                  <el-date-picker
                    v-model="useDate"
                    :class="{ error: errors.has('useDate') }"
                    :picker-options="datePickerOptions.notBeforeToday"
                    :default-time="['00:00:00', '23:59:59']"
                    :disabled="!canUpdateContent"
                    format="dd-MM-yyyy HH:mm"
                    start-placeholder="เริ่มกิจกรรม/ใช้สิทธิ์"
                    end-placeholder="สิ้นสุดกิจกรรม/ใช้สิทธิ์"
                    range-separator="ถึง"
                    type="datetimerange"
                    @change="validate"
                  >
                  </el-date-picker>
                </div>
              </label>
            </dd>
            <div v-if="showQuotaOptions">
              <dt>จำนวนสิทธิ์</dt>
              <dd>
                <div>
                  <label class="select-input">
                    <span>จำกัดสิทธิ์</span>
                    <input
                      v-model="conditions.quotaType"
                      :disabled="!canUpdateContent"
                      type="radio"
                      value="LIMITED"
                      name="quota"
                    />
                    <span class="checkmark radio"></span>
                  </label>
                  <label class="select-input">
                    <span>ไม่จำกัดสิทธิ์</span>
                    <input
                      v-model="conditions.quotaType"
                      :disabled="!canUpdateContent"
                      type="radio"
                      value="UNLIMITED"
                      name="quota"
                    />
                    <span class="checkmark radio"></span>
                  </label>
                </div>
                <div v-if="showSpecificQuotaOptions">
                  <label class="sub-input">
                    <small>ระบุจำนวนสิทธิ์</small>
                    <input
                      v-model="events.quota"
                      :disabled="!canUpdateContent"
                      type="text"
                      value=""
                      name="quotaPreview"
                      class="form-control"
                    />
                  </label>
                </div>
              </dd>
            </div>
            <div v-if="showWaitingListOptions">
              <label class="select-input">
                <span>ให้มี Waiting List ( สิทธิ์สำรอง )</span>
                <input
                  v-model="conditions.waitingList"
                  :disabled="!canUpdateContent"
                  type="checkbox"
                  value=""
                />
                <span class="checkmark checkbox"></span>
              </label>
              <div v-if="showWaitingListQuotaOptions">
                <label class="sub-input">
                  <small>ระบุจำนวนสิทธิ์สำรอง</small>
                  <input
                    v-model="events.totalReserve"
                    :disabled="!canUpdateContent"
                    type="text"
                    value=""
                    name="totalReserve"
                    class="form-control"
                  />
                </label>
              </div>
            </div>
          </dl>
        </dd>
        <dt class="col-md-3">บาร์โค้ด</dt>
        <dd :class="isDisabledClass" class="col-md-9">
          <label :class="isDisabledClass" class="select-input">
            <span>แสดงบาร์โค้ด</span>
            <input
              v-model="events.showBarcode"
              :disabled="!canUpdateContent"
              type="radio"
              value="true"
              name="showBarcodeTrue"
            />
            <span class="checkmark radio"></span>
          </label>
          <label :class="isDisabledClass" class="select-input">
            <span>ไม่แสดงบาร์โค้ด</span>
            <input
              v-model="events.showBarcode"
              :disabled="!canUpdateContent"
              type="radio"
              value="false"
              name="showBarcodeFalse"
            />
            <span class="checkmark radio"></span>
          </label>
          <dl class="form-options">
            <div v-if="showBarcodeRemark">
              <dt>คำอธิบายใต้บาร์โค้ด</dt>
              <dd>
                <label class="form-group">
                  <small>แก้ไขคำอธิบาย</small>
                  <input
                    v-model="events.barcodeRemark"
                    :disabled="!canUpdateContent"
                    type="text"
                    name="barcodeRemark"
                    class="form-control barcode-remark"
                    maxlength="200"
                    placeholder="แสดง code นี้กับเจ้าหน้าที่เพื่อรับสิทธิ์"
                  />
                </label>
              </dd>
            </div>
          </dl>
        </dd>
      </dl>
    </div>
    <info-dialog
      v-if="showDialog === true"
      :title="'รูปแบบของไฟล์ CSV'"
      @isShow="showDialog = false"
    >
      <div class="row">
        <div class="col-md-8">
          <img
            src="/static/pictures/article-guide-csv.jpg"
            alt="csv content guide"
            class="w-100"
          />
        </div>
        <div class="col-md-4">
          <p>
            รูปแบบของรหัส
            จะต้องประกอบด้วยตัวเลขหรือตัวหนังสือภาษาอังกฤษรวมทั้งหมด 8
            ตัวซึ่งจะต้องอยู่ในคอลัมน์เดียว และไม่ต้องใส่หัวตาราง ตามรูปประกอบ
          </p>
        </div>
      </div>
    </info-dialog>
  </div>
</template>
<script>
import csv from "csvtojson"
import Moment from "moment"
import { DatePicker } from "element-ui"
import "element-ui/lib/theme-chalk/index.css"
import Information from "@/components/helper/dialog/Information"

export default {
  components: {
    "el-date-picker": DatePicker,
    "info-dialog": Information,
  },
  props: {
    eventSettings: {
      type: null,
      default: undefined,
    },
    canUpdateContent: {
      type: null,
      default: undefined,
    },
    isThaiLanguage: {
      type: null,
      default: undefined,
    },
  },
  data() {
    return {
      conditions: {
        question: false,
        codeType: "PREFIXED",
        quotaType: "LIMITED",
        waitingList: false,
      },
      datePickerOptions: {
        notBeforeToday: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 3600 * 1000 * 24
          },
        },
      },
      events: {
        type: "IMMEDIATE", // or REGISTER
        usageType: "ACTIVITY", // or REDEEM
        startActivateDate: "",
        endActivateDate: "",
        startUseDate: "",
        endUseDate: "",
        prefixCode: "SC",
        quota: 10,
        totalReserve: 10,
        question: null,
        codes: null,
        showBarcode: true,
        barcodeRemark: "แสดง code นี้กับเจ้าหน้าที่เพื่อรับสิทธิ์",
      },
      file: {
        codes: [],
        errors: [],
      },
      showDialog: false,
    }
  },
  computed: {
    activateDate: {
      get() {
        return [
          this.events.startActivateDate || "",
          this.events.endActivateDate || "",
        ]
      },
      set(datetimeArray) {
        if (datetimeArray === null) {
          this.events.startActivateDate = ""
          this.events.endActivateDate = ""
        } else {
          const [startActivateDate, endActivateDate] = datetimeArray
          this.events.startActivateDate = startActivateDate
          this.events.endActivateDate = endActivateDate
        }
      },
    },
    useDate: {
      get() {
        return [this.events.startUseDate || "", this.events.endUseDate || ""]
      },
      set(datetimeArray) {
        if (datetimeArray === null) {
          this.events.startUseDate = ""
          this.events.endUseDate = ""
        } else {
          const [startUseDate, endUseDate] = datetimeArray
          this.events.startUseDate = startUseDate
          this.events.endUseDate = endUseDate
        }
      },
    },
    showTypeOptions() {
      if (this.events.type === "REGISTER") {
        return true
      }

      return false
    },
    showTypeQuestionOptions() {
      if (
        this.events.type === "REGISTER" &&
        this.conditions.question === true
      ) {
        return true
      }

      return false
    },
    showRandomCodeOptions() {
      if (this.conditions.codeType === "PREFIXED") {
        return true
      }

      return false
    },
    showUploadCodeOptions() {
      if (this.conditions.codeType === "PREDEFINED") {
        return true
      }

      return false
    },
    showQuotaOptions() {
      if (this.conditions.codeType === "PREFIXED") {
        return true
      }

      return false
    },
    showSpecificQuotaOptions() {
      if (this.conditions.quotaType === "LIMITED") {
        return true
      }

      return false
    },
    showWaitingListOptions() {
      if (
        this.events.type === "REGISTER" &&
        this.conditions.quotaType !== "UNLIMITED"
      ) {
        return true
      }

      return false
    },
    showWaitingListQuotaOptions() {
      if (this.conditions.waitingList === true) {
        return true
      }

      return false
    },
    showBarcodeRemark() {
      return JSON.parse(this.events.showBarcode)
    },
    isDisabledClass() {
      return {
        "disable-content": !this.isThaiLanguage,
      }
    },
  },
  watch: {
    eventSettings() {
      this.events = this.eventSettings

      this.events.startActivateDate = this.events.startActivateDate
        ? Moment(this.events.startActivateDate).toDate()
        : null
      this.events.endActivateDate = this.events.endActivateDate
        ? Moment(this.events.endActivateDate).toDate()
        : null
      this.events.startUseDate = this.events.startUseDate
        ? Moment(this.events.startUseDate).toDate()
        : null
      this.events.endUseDate = this.events.endUseDate
        ? Moment(this.events.endUseDate).toDate()
        : null

      if (this.events.question) {
        this.conditions.question = true
      }

      if (this.events.codes && this.events.codes.length > 0) {
        this.conditions.codeType = "PREDEFINED"
        this.file.codes = this.events.codes
      }

      if (!this.events.quota) {
        this.conditions.quotaType = "UNLIMITED"
      }

      if (this.events.totalReserve) {
        this.conditions.waitingList = true
      }
    },
  },
  created() {},
  methods: {
    readCodesFromCSV(file) {
      const reader = new FileReader()
      const vm = this

      vm.file.codes = []
      vm.file.errors = []

      reader.onload = () => {
        const options = {
          noheader: true,
          ignoreEmpty: true,
          output: "line",
        }

        csv(options)
          .fromString(reader.result)
          .preFileLine((line) => {
            const cleaned = line.toString("utf8")

            vm.file.codes.push(cleaned)

            return cleaned
          })
      }

      reader.readAsText(file)
    },
    updateEvents() {
      const editedEventSettings = {
        type: this.events.type,
        usageType: this.events.usageType,
        startActivateDate: this.events.startActivateDate || null,
        endActivateDate: this.events.endActivateDate || null,
        startUseDate: this.events.startUseDate || null,
        endUseDate: this.events.endUseDate || null,
        showBarcode: this.events.showBarcode || false,
        barcodeRemark: this.events.barcodeRemark || null,
      }

      if (this.events.question && this.events.question.trim().length > 0) {
        editedEventSettings.question = this.events.question.trim()
      } else {
        editedEventSettings.question = null
      }

      if (this.conditions.quotaType === "LIMITED" && this.events.quota > 0) {
        editedEventSettings.quota = this.events.quota
      } else {
        editedEventSettings.quota = null
      }

      if (this.conditions.waitingList && this.events.totalReserve > 0) {
        editedEventSettings.totalReserve = this.events.totalReserve
      } else {
        editedEventSettings.totalReserve = null
      }

      if (this.showRandomCodeOptions) {
        editedEventSettings.prefixCode = this.events.prefixCode
      } else {
        editedEventSettings.prefixCode = "SC"
      }

      if (this.showUploadCodeOptions && this.file.codes.length > 0) {
        this.events.codes = this.file.codes
        editedEventSettings.codes = this.file.codes
        editedEventSettings.quota = this.file.codes.length
      } else {
        this.events.codes = null
      }

      this.$emit("setEvents", editedEventSettings)
    },
    async validate() {
      const result = await this.$validator.validate()
      this.$emit("validate", result)
      return result
    },
  },
}
</script>
<style lang="scss" scoped>
#setting-event {
  overflow-y: scroll;
  height: calc(100vh - 312px);
}
.form {
  padding: 25px 0;

  strong {
    display: inline-block;
    vertical-align: bottom;
    margin: 1rem;
  }

  small {
    font-size: 11px;
    font-weight: 500;
    line-height: 1.64;
    letter-spacing: -0.1px;
    color: #8c8786;
  }

  dt {
    text-align: right;
    font-size: 16px;
    font-weight: bold;
    line-height: 1.38;
    letter-spacing: -0.1px;
    color: $black;
  }

  input:not([type="file"]) {
    color: $black;
    font-weight: bold;
  }

  input:not([type="checkbox"]):not([type="radio"]) {
    padding: 4px 4px 4px 0;
  }

  input[type="file"] {
    height: 35px;
  }

  input[data-prefix] {
    content: attr(data-prefix);
    color: $black;
    display: inline;
  }

  &-options {
    padding: 16px;
    border-radius: 5px;
    background-color: #f9f9f9;

    dt {
      text-align: left;
    }
    .select-input {
      margin-top: 8px;
    }
    .sub-input {
      padding-left: 36px;
    }
  }

  .form-control {
    background-color: transparent;
    border-color: #e0e0e0;
  }
  .barcode-remark {
    width: 400px;
  }
  .select-input {
    color: $black;
  }
  .time-picker-wrapper {
    font-size: 18px;
    font-weight: bold;
    border: none;
    border-bottom: solid 1px #e0e0e0;
    height: 30px;
    margin-top: 0;
    float: left;
    min-width: 220px;
  }
  .date-append-img {
    float: left;
    margin-top: 5px;
    margin-left: -25px;
  }
  .code-preview {
    margin-top: 4px;
    color: $black;
    font-size: 16px;

    em {
      font-weight: bold;
      font-style: normal;
    }
  }
  .code-results {
    ul {
      padding-left: 0;
      margin: 0;
      max-height: 100px;
      overflow: scroll;

      &.error {
        color: $red;
      }

      li {
        font-size: 11px;
        list-style-type: square;
        margin-left: 16px;

        &:first-child {
          margin-left: 0;
          padding-left: 0;
          list-style: none;
        }
      }
    }
  }
}

.disable-content {
  pointer-events: none;
  opacity: 0.5;
}
</style>
